module.exports = __webpack_public_path__ + "static/media/online_store.3cf2863f.svg";